var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import { PwResetHttpServivce } from '../services/pw-reset-http.service';
import ApiError from './ApiError';
import AppMessage from './appMessage';
import SubmitButton from './SubmitButton';
var PwResetForm = /** @class */ (function (_super) {
    __extends(PwResetForm, _super);
    //mockService: PwResetMockHttpService;
    function PwResetForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePw1Change = function (e) {
            _this.setState({ passwordModel: { pw1: e.currentTarget.value, pw2: _this.state.passwordModel.pw2 } });
        };
        _this.handleSubmit = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var response, msg;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.setState({ hasSubmitted: true, isLoading: true, disabled: true });
                        console.log(this.state);
                        return [4 /*yield*/, this.httpService
                                .updatePw(this.state.passwordModel, this.props.token)
                                .catch(function (error) { return error.response; })
                                .finally(function () { return _this.setState({ isLoading: false }); })];
                    case 1:
                        response = _a.sent();
                        switch (response.status) {
                            case 200:
                            case 204:
                                this.setState({ success: true, errorType: undefined, error: null, done: true });
                                break;
                            case 400: {
                                console.log(response);
                                msg = response.data.message;
                                if ("compromised_password" === msg) {
                                    this.setState({ errorType: 'compromised_password', disabled: false });
                                }
                                else {
                                    this.setState({ errorType: 'pw_policy', disabled: false });
                                }
                                break;
                            }
                            case 401:
                                this.setState({ errorType: 'token_invalid' });
                                break;
                            case 403:
                                this.setState({ errorType: response.data.message });
                                break;
                            default:
                                this.setState({ errorType: 'uknown_error', error: response.data });
                                break;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            hasSubmitted: false,
            isLoading: false,
            passwordModel: {
                pw1: '',
                pw2: '',
            },
            success: false,
            disabled: false,
            done: false,
        };
        return _this;
    }
    PwResetForm.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.httpService = new PwResetHttpServivce();
                        return [4 /*yield*/, this.httpService.getPolicy(this.props.token)];
                    case 1:
                        response = _a.sent();
                        console.log(response.data);
                        this.setState({ policy: response.data });
                        return [2 /*return*/];
                }
            });
        });
    };
    PwResetForm.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19;
        return (React.createElement(React.Fragment, null,
            ((_a = this.state) === null || _a === void 0 ? void 0 : _a.errorType) ? React.createElement(ApiError, { error: (_b = this.state) === null || _b === void 0 ? void 0 : _b.error, errorType: (_c = this.state) === null || _c === void 0 ? void 0 : _c.errorType }) : React.createElement(React.Fragment, null),
            ((_d = this.state) === null || _d === void 0 ? void 0 : _d.success) ? React.createElement(AppMessage, { success: true, message: 'Ihr Passwort wurde ge\u00E4ndert.' }) : React.createElement(React.Fragment, null),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'small-12 large-10 large-centered columns helper-margin-top-s', hidden: (_e = this.state) === null || _e === void 0 ? void 0 : _e.done },
                    React.createElement("h1", null,
                        React.createElement(Trans, null, "Passwort \u00E4ndern")),
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'small-12 large-8 columns' },
                            React.createElement("form", { id: 'setpwForm', name: 'setpwForm', noValidate: true, onSubmit: this.handleSubmit },
                                React.createElement("fieldset", { className: 'helper-no-margin-top', disabled: (_f = this.state) === null || _f === void 0 ? void 0 : _f.disabled },
                                    React.createElement("div", { className: 'row' },
                                        React.createElement("div", { className: 'small-6 medium-3 columns' },
                                            React.createElement("label", { htmlFor: 'pw1' },
                                                React.createElement(Trans, null, "Neues Passwort"),
                                                ":")),
                                        React.createElement("div", { className: 'small-12 medium-6 columns end' },
                                            React.createElement("input", { type: 'password', id: 'pw1', name: 'pw1', onChange: this.handlePw1Change, value: (_h = (_g = this.state) === null || _g === void 0 ? void 0 : _g.passwordModel) === null || _h === void 0 ? void 0 : _h.pw1 }),
                                            React.createElement("small", { className: "error " + (((_j = this.state) === null || _j === void 0 ? void 0 : _j.hasSubmitted) && ((_l = (_k = this.state) === null || _k === void 0 ? void 0 : _k.passwordModel) === null || _l === void 0 ? void 0 : _l.pw1) === '' ? 'show' : 'hide') },
                                                React.createElement(Trans, null, "Passwort erforderlich")))),
                                    React.createElement("div", { className: 'row' },
                                        React.createElement("div", { className: 'small-6 medium-3 columns' },
                                            React.createElement("label", { htmlFor: 'pw2' },
                                                React.createElement(Trans, null, "Neues Passwort (wiederholen)"),
                                                ":")),
                                        React.createElement("div", { className: 'small-12 medium-6 columns end' },
                                            React.createElement("input", { type: 'password', id: 'pw2', name: 'pw2', onChange: function (e) { return _this.setState({ passwordModel: { pw2: e.currentTarget.value, pw1: _this.state.passwordModel.pw1 } }); }, value: (_o = (_m = this.state) === null || _m === void 0 ? void 0 : _m.passwordModel) === null || _o === void 0 ? void 0 : _o.pw2 }),
                                            React.createElement("small", { className: "error " + (((_p = this.state) === null || _p === void 0 ? void 0 : _p.hasSubmitted) && ((_r = (_q = this.state) === null || _q === void 0 ? void 0 : _q.passwordModel) === null || _r === void 0 ? void 0 : _r.pw2) === '' ? 'show' : ' hide') },
                                                React.createElement(Trans, null, "Wiederholen Passwort erforderlich")),
                                            React.createElement("small", { className: "error " + (((_s = this.state) === null || _s === void 0 ? void 0 : _s.hasSubmitted) && ((_u = (_t = this.state) === null || _t === void 0 ? void 0 : _t.passwordModel) === null || _u === void 0 ? void 0 : _u.pw1) !== ((_w = (_v = this.state) === null || _v === void 0 ? void 0 : _v.passwordModel) === null || _w === void 0 ? void 0 : _w.pw2) ? 'show' : ' hide') },
                                                React.createElement(Trans, null, "Die Passw\u00F6rter sind nicht gleich")))),
                                    React.createElement("div", { className: 'row helper-margin-bottom-m' },
                                        React.createElement("div", { className: 'small-12 medium-6 end columns medium-offset-3' },
                                            React.createElement(SubmitButton, { isLoading: (_x = this.state) === null || _x === void 0 ? void 0 : _x.isLoading, disabled: (_y = this.state) === null || _y === void 0 ? void 0 : _y.disabled })))))),
                        React.createElement("div", { className: 'small-12 large-4 columns' },
                            React.createElement(Trans, null, "Das Passwort"),
                            React.createElement("ul", null,
                                React.createElement("li", null,
                                    React.createElement(Trans, { i18nKey: 'minLength', count: (_0 = (_z = this.state) === null || _z === void 0 ? void 0 : _z.policy) === null || _0 === void 0 ? void 0 : _0.minLength },
                                        "muss mindestens ",
                                        { count: (_2 = (_1 = this.state) === null || _1 === void 0 ? void 0 : _1.policy) === null || _2 === void 0 ? void 0 : _2.minLength },
                                        " Zeichen lang sein")),
                                React.createElement("li", null,
                                    React.createElement(Trans, { i18nKey: 'maxLength', count: (_4 = (_3 = this.state) === null || _3 === void 0 ? void 0 : _3.policy) === null || _4 === void 0 ? void 0 : _4.maxLength },
                                        "darf h\u00F6chstens ",
                                        { count: (_6 = (_5 = this.state) === null || _5 === void 0 ? void 0 : _5.policy) === null || _6 === void 0 ? void 0 : _6.maxLength },
                                        " Zeichen lang sein")),
                                ((_8 = (_7 = this.state) === null || _7 === void 0 ? void 0 : _7.policy) === null || _8 === void 0 ? void 0 : _8.basicLatinOnly) ? React.createElement("li", { id: 'onlyASCII' },
                                    React.createElement(Trans, { i18nKey: "basicLatinOnly" }, "darf keine Umlaute enthalten (nur ASCII)")) : React.createElement(React.Fragment, null),
                                React.createElement("li", null,
                                    React.createElement(Trans, { i18nKey: "minNotLetters", count: (_10 = (_9 = this.state) === null || _9 === void 0 ? void 0 : _9.policy) === null || _10 === void 0 ? void 0 : _10.minNotLetters },
                                        "muss mindestens ",
                                        { count: (_12 = (_11 = this.state) === null || _11 === void 0 ? void 0 : _11.policy) === null || _12 === void 0 ? void 0 : _12.minNotLetters },
                                        " Sonderzeichen oder Zahlen enthalten")),
                                React.createElement("li", null,
                                    React.createElement(Trans, { i18nKey: "minLetters", count: (_14 = (_13 = this.state) === null || _13 === void 0 ? void 0 : _13.policy) === null || _14 === void 0 ? void 0 : _14.minLetters },
                                        "muss mindestens ",
                                        { count: (_16 = (_15 = this.state) === null || _15 === void 0 ? void 0 : _15.policy) === null || _16 === void 0 ? void 0 : _16.minLetters },
                                        " Buchstaben enthalten")),
                                React.createElement("li", null,
                                    React.createElement(Trans, { i18nKey: "excludeCharacters" }, "darf folgende Zeichen nicht enthalten"),
                                    ": ", (_19 = (_18 = (_17 = this.state) === null || _17 === void 0 ? void 0 : _17.policy) === null || _18 === void 0 ? void 0 : _18.excludeCharacters) === null || _19 === void 0 ? void 0 :
                                    _19.join(', ')))))))));
    };
    return PwResetForm;
}(Component));
export default PwResetForm;
